import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import accountingReducer from 'features/accounting/slice';
import appUIReducer from 'features/app-ui/slice';
import companyReducer from 'features/company/slice';
import internalDocumentReducer from 'features/internal-document/common/slice';
import { proposalReducer } from 'features/proposal/slice';
import { userReducer } from 'features/user/slice';
import { workReducer } from 'features/work/slice';
import { workScheduleReducer } from 'features/work-schedule/slice';
import { baseApi } from 'lib/rtkQuery/baseApi';

export const store = configureStore({
  reducer: {
    baseApi: baseApi.reducer,
    ui: appUIReducer,
    workSchedule: workScheduleReducer,
    work: workReducer,
    proposal: proposalReducer,
    company: companyReducer,
    internalDocument: internalDocumentReducer,
    user: userReducer,
    accounting: accountingReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // TODO: NamNH: temporary set to false to investigate issues with serialize mutation
      // serializableCheck: {
      //   ignoredPaths: ['scanner.onScan', 'modals'],
      //   ignoredActionPaths: ['payload.onScan', 'payload.element'],
      // },
      serializableCheck: false,
    }).concat(baseApi.middleware),
});

setupListeners(store.dispatch);

export type TAppDispatch = typeof store.dispatch;
export type TRootState = ReturnType<typeof store.getState>;
